import { render, staticRenderFns } from "./breakdownDetails.vue?vue&type=template&id=0d4d5f71&scoped=true"
import script from "./breakdownDetails.vue?vue&type=script&lang=js"
export * from "./breakdownDetails.vue?vue&type=script&lang=js"
import style0 from "./breakdownDetails.vue?vue&type=style&index=0&id=0d4d5f71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4d5f71",
  null
  
)

export default component.exports